<div *ngIf="!loading" class="verify-location-container">
  <div class="self-tour-step-header">
    <div class="text-xl font-denim-semibold">UNABLE TO VERIFY LOCATION</div>
    <h5></h5>
  </div>
  <p class="center-text">When you are in front of the home, please allow Tricon to use your location. Tricon will verify your location and then allow you access to self tour the home. This will only work within 100 feet of the home.</p>
  <div class="flex justify-end">
    <div class="w-full sm:w-1/3">
      <div class="grid grid-cols-1">
        <button mat-flat-button color="accent" (click)="findLocation()">FIND MY LOCATION</button>
      </div>
    </div>
  </div>
  <p>*Note: To be able to use the self tour process, a smart phone with GPS capabilities is required. Location services must be turned on in your smart phone settings.</p>
</div>
<div *ngIf="loading" class="verify-location-container">
  <div class="self-tour-step-header mb-8">
    <div class="text-xl font-denim-semibold">FINDING LOCATION</div></div>
  <div class="flex justify-center"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>
</div>
